/**
 * Cookie key for the locale.
 * This key is used to store the locale in the cookie.
 */
export const localeKey = 'i18n_redirected';
